module.exports = __webpack_public_path__ + "img/职高.e80ccfed.png";